import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = {
  xmlns: "http://www.w3.org/2000/svg",
  width: "16",
  height: "16",
  fill: "inherit"
}

export function render(_ctx, _cache) {
  return (_openBlock(), _createElementBlock("svg", _hoisted_1, _cache[0] || (_cache[0] = [
    _createElementVNode("path", {
      stroke: "currentColor",
      d: "M8.048 2.496a.3.3 0 0 1 .57 0L9.55 5.36a1.3 1.3 0 0 0 1.237.898h3.01a.3.3 0 0 1 .177.543l-2.436 1.77a1.3 1.3 0 0 0-.472 1.453l.93 2.864a.3.3 0 0 1-.461.335l-2.437-1.77a1.3 1.3 0 0 0-1.528 0l-2.436 1.77a.3.3 0 0 1-.461-.335l.93-2.864a1.3 1.3 0 0 0-.472-1.453L2.694 6.8a.3.3 0 0 1 .176-.543h3.011a1.3 1.3 0 0 0 1.237-.898z"
    }, null, -1)
  ])))
}
export default { render: render }